export enum CardTypeEnum {
  CREDIT = 'Credit',
  DEBIT = 'Debit',

}
